import React, { useEffect, useRef, useState } from "react";

import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import InformationPanel from "../../common/InformationPanel";
// import NotesPanel from "../../NotesPanelSection/NotesPanel";
import DocumentRow from "../../DocumentRow/DocumentRow";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import InsuranceIcon from "../../../../public/BP_resources/images/icon/insurance-icon-color.svg";
import { formatDateForPanelDisplay, currencyFormat } from "../../../Utils/helper";
import VerifiedIcon from "../../../assets/verified_yes.png";
import NonVerifiedIcon from "../../../assets/verifiedno.png";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import "../../common/RecordPanel.css";

function InsuranceDetailedView({ insurances, setEditModal, handleEditModalShow, billData }) {
  const formatWithCommas = (value) => {
    if (!value || isNaN(Number(value))) {
      return "";
    }
    return Number(value).toLocaleString();
  };

  const InsuranceButtons = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];

  const LienButtonsConfig = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const EmploymentButtonsConfig2 = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: hoveredIndex ? VerifiedIcon : NonVerifiedIcon,

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {
        setHoveredIndex(true);
      },
      onMouseLeave: () => {
        setHoveredIndex(null);
      },
      onClick: () => {
        setHoveredIndex(true);
      },
    },
  ];

  const extractDataForEditModal = (data) => {
    setEditModal(data);
  };
  const formatInfo = (defendant) => {
    const nameParts = [];

    const firstName = defendant?.first_name;
    const lastName = defendant?.last_name;

    if (lastName && firstName) {
      nameParts.push(`${lastName}, ${firstName}`);
    } else if (lastName || firstName) {
      nameParts.push(lastName || firstName);
    }

    const name = nameParts.join(" ");

    return `${name}`;
  };
  const getName = (type, data = {}) => {
    if (!data) return "";
    const { _first_name = "", _last_name = "", entity_name = "", defendantType = "" } = data;

    const fullName = formatInfo(data);

    if (type === "Defendant") {
      return defendantType?.id === 1 ? fullName : entity_name || "";
    }

    if (type === "Client") {
      return fullName;
    }
    if (type === "OtherParty") {
      const fullName2 = `${data?.party_first_name ?? ""} ${data?.party_last_name ?? ""}`?.trim();
      return fullName2;
    }

    return "";
  };
  const [height, setHeight] = useState(null);
  const insuranceHeightRef = useRef(null);

  useEffect(() => {
    if (insuranceHeightRef.current) {
      setHeight(insuranceHeightRef.current.clientHeight);
    }
  }, [insuranceHeightRef]);
  return (
    <>
      {insurances &&
        [...insurances].map((data, index) => {
          return (
            <div
              className="report record-panel"
              key={data.id}
              style={{
                position: "relative",
              }}
            >
              <PanelActionBarComponent
                compact
                panelIconSrc={InsuranceIcon}
                instanceForName={data?.insurance_type?.name}
                type={data?.insurance_type?.name}
                page_id={11}
                id={data?.id}
                name={getName(data?.entity_type, data?.entity_obj)}
                forInstanceName={`${data?.for_client?.first_name || ""} ${data?.for_client?.last_name || ""}`}
                zIndex={([...insurances].length - index) * 10}
              />
              <div
                className="d-flex flex-wrap mb-0 record-panel-body"
                style={{
                  gap: "5px",
                }}
              >
                <div
                  ref={insuranceHeightRef}
                  className="leins-container-six"
                  onClick={() => extractDataForEditModal(data)}
                >
                  {/* Row 3 - Insurance Company */}
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      panel_name={"Insurance Company"}
                      dynamic_label={"Company Name"}
                      name={data?.company_contact?.name}
                      address1={data?.company_contact?.address1}
                      address2={data?.company_contact?.address2}
                      email={data?.company_contact?.email}
                      phone_number={data?.company_contact?.phone_number}
                      city={data?.company_contact?.city}
                      state={data?.company_contact?.state}
                      zip_code={data?.company_contact?.zip}
                      fax_number={data?.company_contact?.fax}
                      ext={data?.company_contact?.ext}
                      websiteURL={data?.company_contact?.website}
                      onSelectObject={() => handleEditModalShow("company")}
                      buttonData={InsuranceButtons}
                      pageName="Insurance"
                    />
                  </div>

                  {/* Row 1 - Claim Information */}
                  <div className="min-w-260px-client">
                    <InformationPanel
                      panel_name={"Claim Information"}
                      labelClassName="font-weight-600"
                      labelStyle={{ color: "var(--primary-25)" }}
                      valueStyle={{
                        maxWidth: "70%",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                        overflow: "hidden",
                        // color: "var(--primary-25)",
                      }}
                      data={[
                        {
                          label: "Type",
                          value: data?.insurance_type?.name,
                        },
                        {
                          label: "Limits",
                          value: `$ ${formatWithCommas(data?.liabilityLimit)} / ${formatWithCommas(data?.liabilityLimitAll)} $`,
                        },
                        {
                          label: "Policy",
                          value: data?.policy_number,
                        },
                        {
                          label: "Claim",
                          value: data?.claim_number,
                        },
                        {
                          label: "Date",
                          value: formatDateForPanelDisplay(data?.Dateconfirmedactive),
                        },
                      ]}
                      onSelectReport={() => handleEditModalShow("claim")}
                      hasBtn={true}
                      defaultLength={5}
                      buttonData={EmploymentButtonsConfig2}
                    />
                  </div>

                  {/* Row 2 - Adjuster */}
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      panel_name={"Adjuster"}
                      name={`${data?.adjuster?.first_name ? data?.adjuster?.first_name : ""} ${data?.adjuster?.last_name ? data?.adjuster?.last_name : ""}`}
                      address1={data?.adjuster?.address1}
                      address2={data?.adjuster?.address2}
                      email={data?.adjuster?.email}
                      phone_number={data?.adjuster?.phone_number}
                      fax_number={data?.adjuster?.fax}
                      city={data?.adjuster?.city}
                      state={data?.adjuster?.state}
                      zip_code={data?.adjuster?.zip}
                      ext={data?.adjuster?.ext}
                      websiteURL={data?.adjuster?.website}
                      onSelectObject={() => handleEditModalShow("adjuster")}
                      buttonData={InsuranceButtons}
                      pageName="Insurance"
                    />
                  </div>

                  {/* Row 4 - Supervisor */}
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      panel_name={"Supervisor"}
                      pageName="Insurance"
                      name={`${data?.supervisor?.first_name ? data?.supervisor?.first_name : ""} ${data?.supervisor?.last_name ? data?.supervisor?.last_name : ""}`}
                      address1={data?.supervisor?.address1}
                      address2={data?.supervisor?.address2}
                      email={data?.supervisor?.email}
                      city={data?.supervisor?.city}
                      state={data?.supervisor?.state}
                      zip_code={data?.supervisor?.zip}
                      phone_number={data?.supervisor?.phone_number}
                      fax_number={data?.supervisor?.fax}
                      websiteURL={data?.supervisor?.website}
                      ext={data?.supervisor?.ext}
                      onSelectObject={() => handleEditModalShow("supervisor")}
                      buttonData={InsuranceButtons}
                    />
                  </div>

                  {/* Row 6 - Lien Collector */}
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      name={`${data?.lien_adjuster?.first_name || ""} ${data?.lien_adjuster?.last_name || ""}`}
                      address1={data?.lien_adjuster?.contact?.address1}
                      address2={data?.lien_adjuster?.contact?.address2}
                      email={data?.lien_adjuster?.contact?.email}
                      phone_number={data?.lien_adjuster?.contact?.phone_number}
                      panel_name={"Lien Adjuster"}
                      buttonData={LienButtonsConfig}
                      dynamic_label={"Full Name"}
                      city={data?.lien_adjuster?.contact?.city}
                      state={data?.lien_adjuster?.contact?.state}
                      zip_code={data?.lien_adjuster?.contact?.zip}
                      fax_number={data?.lien_adjuster?.contact?.fax}
                      ext={data?.lien_adjuster?.contact?.ext}
                      websiteURL={data?.lien_adjuster?.contact?.website}
                      pageName="Insurance"
                      onSelectObject={() => handleEditModalShow("lien")}
                    />
                  </div>

                  {/* Row 5 - Lien */}
                  <div className="min-w-260px-client">
                    <InformationPanel
                      onSelectReport={() => handleEditModalShow("lien_adjuster")}
                      panel_name={"Lien"}
                      className=""
                      labelClassName="font-weight-600"
                      labelStyle={{ color: "var(--primary-25)" }}
                      data={[
                        {
                          label: "Contact",
                          value: data?.lien_adjuster?.name ? data?.lien_adjuster?.name : "",
                        },
                        {
                          label: "HI Paid",
                          value: billData?.total_ins_paid
                            ? currencyFormat(billData?.total_ins_paid)
                            : "$ 0.00",
                        },
                        {
                          label: "Total Paid",
                          value: `${currencyFormat(data?.insurancelien_insurance?.totalpaid)}`,
                        },
                        {
                          label: "Original Lien",
                          value: `${currencyFormat(data?.insurancelien_insurance?.liens)}`,
                        },
                        {
                          label: "Final Lien",
                          value: `${currencyFormat(data?.insurancelien_insurance?.lienfinal)}`,
                        },
                      ]}
                      hasBtn={true}
                      defaultLength={5}
                      buttonData={EmploymentButtonsConfig2}
                    />
                  </div>
                </div>

                {/* Notes Panel */}
                <div
                  className=""
                  style={{
                    flex: 1,
                    minHeight: "155px",
                    paddingRight: "0px",
                    scrollbarWidth: "none",
                    minWidth: "min(400px, 100%)",
                    maxHeight: `${height}px`,
                  }}
                >
                  <p className="menu-bar-style columnsTitle text-center">Notes</p>
                  <TreatmentNotesSection
                    record_id={data.id}
                    instanceFor="Defendants"
                    module={"Insurance"}
                    notesName={"Insurance"}
                    pagePanels={6}
                  />
                  {/* <NotesPanel
                    record_id={data.id}
                    instanceFor="Defendants"
                    module={"Insurance"}
                    notesName={"Insurance"}
                    pagePanels={6}
                  /> */}
                </div>
              </div>

              {/* Document Row */}
              <div className="m-t-5 documents-wrapper">
                <div className="col-12">
                  {/* <div className="height-25">
                    <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
                      &nbsp;Document Row
                    </h4>
                  </div> */}
                  <DocumentRow clientProvider={data} page_id={11} showSaveToPage={false} />
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
}

export default React.memo(InsuranceDetailedView);
